import SimpleTabs from './SimpleTabs';

export default SimpleTabs;
